/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_145Inputs */

const cs_ares_legal_form_145 = /** @type {(inputs: Ares_Legal_Form_145Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spolek`)
};

const en_ares_legal_form_145 = /** @type {(inputs: Ares_Legal_Form_145Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Association`)
};

/**
* | output |
* | --- |
* | "Association" |
*
* @param {Ares_Legal_Form_145Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_145 = /** @type {((inputs?: Ares_Legal_Form_145Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_145Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_145(inputs)
	return cs_ares_legal_form_145(inputs)
});